import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useHistory } from "react-router-dom";
import moment from "moment";
import CryptoJS from "crypto-js";

import {
  AddIconV2,
  FolderEmpty,
  NoDataIcon,
} from "../../../assets/Logos/Icons";
import { getFileTypeFromFileName } from "../../../Helpers/FileHelper";
import { uploadreportfromhistory } from "../../../actions/UploadAction";
import ConformModal from "../../Modals/Reusable Modals/ConformModal";
import ConfirmModalDelete from "./ConfirmModal";
import FileformatModal from "./ConfirmModal/FileformatModal";
import {
  fetchAppointmentHistory,
  fetchSelectedAppointmentDetails,
} from "../../../actions/AppointmentActions";
import { SERVER_API_URL } from "../../../apis";
import "./appointmentindex.css";
import { FileDrop } from "react-file-drop";
import FileViewModal from "../../Modals/FileViewModal/FileViewModal";
import Prescription from "../../PrintPrescription/PrintPrescription";
import { AssetStore } from "../../../assets/AssetsStore";
import { DrDashboardContext } from "../../DoctorDashboard/DoctorDashboard";

function AppointmentHistoryModalContent({ goToCreatePrescription, loading }) {
  var hashcode = CryptoJS.SHA256(
    process.env.REACT_APP_PREFIX +
      process.env.REACT_APP_TOKEN +
      process.env.REACT_APP_SECRETKEY
  );

  let uploadedArray = [];

  const dispatch = useDispatch();
  let appointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.selectedAppointment
  );
  const history = useHistory();
  const fileUploadRef = useRef();
  const fileInputRefHidden = useRef(null);
  const [error, setError] = useState(false);
  const [deleteItems, setDeleteItem] = useState("");
  const [errorLimit, setErrorLimit] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadshow, setUploadshow] = useState(false);

  const [toastOpen, setToastOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  let [actionModal, setActionModal] = useState(false);

  const [fileItem, setFileName] = useState([]);
  let [filename, setfilename] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  let [errorMessage, setErrorMessage] = useState("File type not supported");
  const [clickedFile, setClickedFile] = useState(null);
  const [fileViewModal, setFileVIewModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const [uploads, setUploads] = useState([]);
  let [fileActionModal, setFileActionModal] = useState(false);
  let downloadFile = (file) => {
    window.open(file, "_blank");
  };

  let handleOpenUrl = (url) => {
    window.open(url, "_blank");
  };
  const onUploadClick = () => {
    fileUploadRef.current.click();
    setUploadshow(true);
  };
  const userData = JSON.parse(localStorage.getItem("userData"));

  const onFileChange = (file, e) => {
    let restrictions = [
      "pdf",
      "png",
      "jpeg",
      "jpg",
      "doc",
      "docx",
      "dcm",
      "zip",
      "PDF",
      "PNG",
      "JPEG",
      "JPG",
      "DOC",
      "DOCX",
      "DCM",
      "ZIP",
    ];

    let ext = file.name.split(".")?.pop();

    if (restrictions.includes(ext)) {
      let imgSize = parseFloat(file?.size / (1024 * 1024)).toFixed(2);

      if (uploads) {
        if (uploads?.length <= 4) {
          if (imgSize < 5) {
            setError(false);
            setUploading(true);
            const formData = new FormData();
            formData.append("name", file.name);
            formData.append("file", file);
            formData.append(
              "appintmentId",
              appointmentHistoryRedux?.[0].appointmentId
            );
            formData.append("source", "Patient");

            // dispatch(
            //     updatereports({
            //         formData
            //     })
            //   ).then((res) => {

            //     console.log("book_slot API result ==> ", res);

            //     // setPaymentLoading(false)

            //     // progressIncrementer()
            //   });

            axios
              .post(SERVER_API_URL + "/reportsuploads", formData, {})
              .then((res) => {
                console.log("123", res);

                let imgname = res.data.data.fileName?.split(
                  "!./FileSeperator/.!,"
                );

                setFileName([...fileItem, res.data && res.data.data.fileName]);

                setShowError(false);
                setUploads([
                  ...uploads,
                  {
                    title: imgname[0],
                    filetypes: ext,
                    filename: imgname[0],
                    uploaded: moment().format("DD-MM-YYYY"),
                    status: true,
                    resName: res.data.data.fileName,
                    fileurl: res.data.data.fileurl,
                  },
                ]);
              })
              .catch((error) => {});
          } else {
            setError(true);
            setErrorMessage(
              "Please select file size less than 5 MB.If the file is in max size, upload the files to "+appointmentHistoryRedux?.[0].spcialityEmail+"."
            );
            // setActionModal(true)

            if (!toastOpen) {
              toast.error(
                "Please select file size less than 5 MB.If the file is in max size, upload the files to ."+appointmentHistoryRedux?.[0].spcialityEmail,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true,
                  onOpen: (props) => setToastOpen(true),
                  onClose: (props) => setToastOpen(false),
                }
              );
            }
          }
        } else {
          if (!toastOpen) {
            toast.error("Only 5 files are allowed to upload", {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true,
              onOpen: (props) => setToastOpen(true),
              onClose: (props) => setToastOpen(false),
            });
          }
        }
      } else {
        if (imgSize < 5) {
          setError(false);
          setUploading(true);
          const formData = new FormData();
          formData.append("name", file.name);
          formData.append("file", file);
          formData.append(
            "appintmentId",
            appointmentHistoryRedux?.[0].appointmentId
          );
          formData.append("source", "Patient");

          axios
            .post(SERVER_API_URL + "reportsuploads", formData, {})
            .then((res) => {
              console.log(res);
              //let imgname =  file.name
              setUploading(false);
              let imgname = res.data.data.fileName?.split(
                "!./FileSeperator/.!,"
              );

              setFileName([...fileItem, res.data && res.data.data.fileName]);

              setShowError(false);
              setUploads([
                {
                  title: imgname[0],
                  filename: imgname[0],
                  filetypes: ext,
                  uploaded: moment().format("DD-MM-YYYY"),
                  status: true,
                  resName: res.data.data.fileName,
                  fileurl: res.data.data.fileurl,
                },
              ]);
            })
            .catch((error) => {});
        } else {
          setError(true);
        }
      }
    } else {
      setError(true);
      setErrorMessage("File type not supported");
      //setActionModal(true)
      if (!toastOpen) {
        toast.error("File type not supported", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          onOpen: (props) => setToastOpen(true),
          onClose: (props) => setToastOpen(false),
        });
      }
    }
  };
  const deleteUploads = (item) => {
    console.log("item", item);
    setFileActionModal(true);
    setDeleteItem(item);
    setClickedFile(item);
  };

  const toggleFileActionModal = (flag) => {
    setFileActionModal(flag ? flag : false);
  };

  const toggleFileViewModal = (flag) => {
    setFileVIewModal(flag ? flag : false);
  };

  const onRemoveFile = (item) => {
    console.log(item);
    axios
      .post(
        SERVER_API_URL + "removereports",

        {
          requestType: 596,
          token: hashcode.toString(),
          data: { filename: item.filename },
        }
      )
      .then((res) => {
        // if (res.data.info === "Success") {
        console.log(res);
        setUploads(uploads.filter((e) => e.title != item.filename));
        setShowModal(false);
        // } else {
        // }
      })
      .catch((error) => {});
  };

  let handleFileRemoveAction = () => {
    setShowModal(true);
    toggleFileActionModal();
  };

  let handleFilePreviewAction = () => {
    setFileVIewModal(true);
    toggleFileActionModal();
  };

  var selectfile = [];
  const Updatereports = () => {
    uploads.map((each, key) => {
      setfilename([...filename, each.resName]);
      selectfile.push(each.resName);
    });

    console.log(selectfile.toString());
    dispatch(
      uploadreportfromhistory({
        appointmentId: appointmentHistoryRedux?.[0].appointmentId
          ? appointmentHistoryRedux?.[0].appointmentId
          : null,
        filename: selectfile.toString(),
      })
    ).then((res) => {
      console.log("**************uploadreportfromhistory API result ==> ", res);
      if (
        res?.data?.data?.filename != null &&
        res?.data?.data?.filename != undefined
      ) {
        setUploads([]);
        setUploadshow(false);
        dispatch(
          fetchSelectedAppointmentDetails({
            appointmentId: appointmentHistoryRedux?.[0].appointmentId
              ? appointmentHistoryRedux?.[0].appointmentId
              : null,
            userData,
          })
        ).then((res) => {
          //  setUploading(false)
        });
      }
    });
  };

  let isBackDated = () => {
    let date = appointmentHistoryRedux?.[0]?.appointmentDate;
    let status = appointmentHistoryRedux?.[0]?.appointmentStatus;
    console.log("appointmentHistoryRedux?.[0]?", appointmentHistoryRedux?.[0]);
    if (status === "Upcoming") {
      return (
        moment(new Date(date).setHours(0, 0, 0, 0)) <
        moment(new Date().setHours(0, 0, 0, 0))
      );
    } else {
      return true;
    }
  };

  let is24hrDated = () => {
    let date = appointmentHistoryRedux?.[0]?.appointmentDate;
    let status = appointmentHistoryRedux?.[0]?.appointmentStatus;

    // Check if the appointment status is not "Upcoming"
    if (status !== "Upcoming") {
      // Create a moment object for the appointment date at 00:00:00
      let appointmentMoment = moment(new Date(date).setHours(0, 0, 0, 0));

      // Create a moment object for the current date and time at 24:00:00
      let currentMoment = moment(new Date().setHours(24, 0, 0, 0));

      // Compare the appointment date with the current date + 24 hours
      return appointmentMoment < currentMoment;
    } else {
      // If the appointment status is "Upcoming", return true
      return false;
    }
  };

  const filteredReportDetails =
    appointmentHistoryRedux?.[0].reportDetails.filter((item) => item.source);
  const filteredwithoursourceReportDetails =
    appointmentHistoryRedux?.[0].reportDetails.filter((item) => !item.source);

  let isDoctor = () => {
    let date = appointmentHistoryRedux?.[0]?.appointmentDate;

    return userData.userType === "Doctor" ? true : false;
  };

  console.log("uploads", uploads);

  return (
    <>
      <div className="ahmc-container">
        <div className="ahmc-container_header">
          Appointment ID - {appointmentHistoryRedux?.[0].appointmentId}
        </div>

        <div className="appointment-timeline">
          <div className="step">
            <div className="step-graph">
              <div className="round">
                <img src={AssetStore.appointmentHistory.forYello} alt="" />
              </div>
              <div className="length">&nbsp;</div>
            </div>

            <div className="step-text">
              <div className="date">
                {appointmentHistoryRedux?.[0].appointmentDate}
              </div>

              <div className="c-row">
                For - &nbsp;
                <div className="date">
                  {" "}
                  {appointmentHistoryRedux?.[0].appointmentForName}
                </div>
              </div>

              {appointmentHistoryRedux?.[0]?.prescriptionsDetails?.medicine !=
                undefined && (
                <ul>
                  <li
                    onClick={() => {
                      handleOpenUrl(
                        appointmentHistoryRedux?.[0]?.prescriptionsDetails
                          ?.medicine
                      );
                    }}
                  >
                    Prescription
                  </li>
                </ul>
              )}

              {filteredReportDetails?.length > 0 && (
                <>
                  <div
                    className="row"
                    style={{ marginBottom: "0", fontWeight: "bold" }}
                  >
                    Report(s) uploaded by doctor
                  </div>
                  <ul>
                    {filteredReportDetails.map((element, key) => {
                      if (
                        element.filename != "" &&
                        element.filename != null &&
                        element.source != "" &&
                        element.source != null
                      ) {
                        return (
                          <li
                            style={{
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              maxWidth: "100px",
                              marginTop: "0",
                            }}
                            onClick={() => {
                              downloadFile(element.filecontent);
                            }}
                          >{`File ${key + 1}`}</li>
                        );
                      }
                    })}
                  </ul>
                </>
              )}

              <div className="c-row">No further input from your provider</div>

              <div className="step-end">&nbsp;</div>
            </div>
          </div>

          <div className="step">
            <div className="step-graph">
              <div className="round yellow">
                <img src={AssetStore.appointmentHistory.forGreen} alt="" />
              </div>
              <div className="length">&nbsp;</div>
            </div>

            <div className="step-text">
              <div className="date">
                {appointmentHistoryRedux?.[0].appointmentbookedDate}
              </div>

              <div className="c-row">
                For - &nbsp;
                <div className="date">
                  {appointmentHistoryRedux?.[0].doctorName}
                </div>
              </div>

              <div className="c-row">
                Patient Name - &nbsp;{" "}
                <div className="date">
                  {appointmentHistoryRedux?.[0].appointmentForName}{" "}
                  {appointmentHistoryRedux?.[0].appointmentFor ===
                    "Loved One" && (
                    <span style={{ fontWeight: "normal" }}>
                      ( Booked by {appointmentHistoryRedux?.[0].patientName}){" "}
                    </span>
                  )}{" "}
                </div>
              </div>

              <div className="row" style={{ marginBottom: "0" }}>
                Reports from patient
              </div>

              <ul style={{ marginBottom: "0", marginTop: "0" }}>
                {appointmentHistoryRedux?.[0].reportDetails?.length > 0 ? (
                  filteredwithoursourceReportDetails.map((element, key) => {
                    if (element.filename != "" && element.filename != null) {
                      uploadedArray.push(
                        element.filename + "!./FileSeperator/.!,"
                      );
                      return (
                        <li
                          style={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "100px",
                            marginTop: "0",
                          }}
                          onClick={() => {
                            downloadFile(element.filecontent);
                          }}
                        >{`Report ${key + 1}`}</li>
                      );
                    }
                  })
                ) : (
                  <div className="consultation-no-reports">
                    No reports from patient
                  </div>
                )}
              </ul>

              {isBackDated()
                ? null
                : !isDoctor() && (
                    <div className="appointment_hostory_report_uploader_wrap">
                      <div
                        className="appointment_hostory_report_uploader_header"
                        onClick={onUploadClick}
                      >
                        Click + button to upload reports
                        <AddIconV2 />
                        <input
                          onChange={(e) => {
                            onFileChange(e.target.files[0]);
                          }}
                          ref={fileUploadRef}
                          type="file"
                          name=""
                          id=""
                        />
                      </div>

                      <span className="supportformatspan">
                        {" "}
                        (Supported formats - PDF, PNG, JPEG, JPG, DOC, DOCX,
                        DCM,ZIP. File limits - 5 files of 5MB per file)
                      </span>

                      <span className="supportformatspan">
                        {" "}
                        If the file is in max size, upload the files to {""}
                       {appointmentHistoryRedux?.[0].spcialityEmail}
                      </span>
                      <span className="supportformatspan"> </span>

                      {uploads && uploads.length > 0 ? (
                        <FileDrop
                          className="appointment_hostory_report_uploader_body"
                          restrictions={{
                            allowedExtensions: [
                              ".pdf",
                              ".png",
                              ".jpeg",
                              ".jpg",
                              ".doc",
                              ".docx",
                              ".dcm",
                              ".zip",
                              ".PDF",
                              ".PNG",
                              ".JPEG",
                              ".JPG",
                              ".DOC",
                              ".DOCX",
                              ".DCM",
                              ".ZIP",
                            ],
                          }}
                          onFrameDragEnter={(event) =>
                            console.log("onFrameDragEnter", event)
                          }
                          onFrameDragLeave={(event) =>
                            console.log("onFrameDragLeave", event)
                          }
                          onFrameDrop={(event) =>
                            console.log("onFrameDrop", event)
                          }
                          onDragOver={(event) =>
                            console.log("onDragOver", event)
                          }
                          onDragLeave={(event) =>
                            console.log("onDragLeave", event)
                          }
                          onDrop={(files, event) => {
                            event.stopPropagation();
                            onFileChange(files[0]);
                          }}
                        >
                          {uploads.map((each, key) => {
                            return (
                              <div className="appointment_history_report_item">
                                <img
                                  src={getFileTypeFromFileName(each.title)}
                                  // className={Style.upload_reports_pdf_icon}
                                ></img>

                                <div className="appointment_history_report_item_overlap">
                                  <div
                                    className="close_icon"
                                    onClick={() => {
                                      deleteUploads(each);
                                    }}
                                  >
                                    x
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </FileDrop>
                      ) : null}

                      {uploadshow && uploads && uploads.length > 0 && (
                        <Button
                          className="btn btn-upload"
                          onClick={Updatereports}
                        >
                          Upload Reports
                        </Button>
                      )}
                    </div>
                  )}

              <div className="row">Other documents</div>

              <ul>
                {appointmentHistoryRedux?.[0]?.otherdocuments?.Consent !=
                  undefined && (
                  <li
                    onClick={() => {
                      handleOpenUrl(
                        appointmentHistoryRedux[0]?.otherdocuments.Consent
                      );
                    }}
                  >
                    Patient Consent Form
                  </li>
                )}
                {appointmentHistoryRedux?.[0]?.otherdocuments?.Invoice !=
                  undefined && (
                  <li
                    onClick={() => {
                      handleOpenUrl(
                        appointmentHistoryRedux[0]?.otherdocuments.Invoice
                      );
                    }}
                  >
                    Consultation Invoice
                  </li>
                )}
              </ul>

              <div className="consultation-end">End of Consultation</div>
            </div>
          </div>
        </div>
      </div>

      {isOpen && <Prescription />}
      <ConformModal
        title="Choose your action"
        okText="Preview"
        closeText="Remove"
        caption=""
        onOk={handleFilePreviewAction}
        onClose={handleFileRemoveAction}
        isShowModal={fileActionModal}
        file={clickedFile}
      />

      <ConfirmModalDelete
        showModal={showModal}
        setShowModal={setShowModal}
        onCancel={onRemoveFile}
        deleteItems={deleteItems}
      />
      <FileformatModal
        showModal={actionModal}
        setShowModal={setActionModal}
        message={errorMessage}
      />

      <FileViewModal
        isShowModal={fileViewModal}
        onClose={() => {
          toggleFileViewModal();
        }}
        file={clickedFile}
      />
    </>
  );
}

export default AppointmentHistoryModalContent;
